import { useUIStore } from '@/stores/ui.store'
import { useAuthStore } from '@/stores/auth.store'
import { useAuth } from '@/hooks/useAuth'
import { Menu, Bell, LogOut, User } from 'lucide-react'

export function Header() {
    const { currentPageTitle, toggleSidebar } = useUIStore()
    const user = useAuthStore((s) => s.user)
    const { signOut } = useAuth()

    return (
        <header className="sticky top-0 z-30 bg-white/80 backdrop-blur-xl border-b border-surface-200">
            <div className="flex items-center justify-between px-4 lg:px-6 h-16">
                {/* Left: Hamburger + Title */}
                <div className="flex items-center gap-3">
                    <button
                        onClick={toggleSidebar}
                        className="lg:hidden p-2 rounded-xl hover:bg-surface-100 transition-colors"
                    >
                        <Menu size={20} className="text-surface-700" />
                    </button>
                    <h1 className="text-lg font-semibold text-surface-900">
                        {currentPageTitle}
                    </h1>
                </div>

                {/* Right: Actions */}
                <div className="flex items-center gap-2">
                    {/* Notifications */}
                    <button className="relative p-2 rounded-xl hover:bg-surface-100 transition-colors">
                        <Bell size={20} className="text-surface-700" />
                        <span className="absolute top-1.5 right-1.5 w-2 h-2 bg-danger-500 rounded-full" />
                    </button>

                    {/* User menu */}
                    <div className="flex items-center gap-3 pl-3 ml-1 border-l border-surface-200">
                        <div className="hidden sm:block text-right">
                            <p className="text-sm font-medium text-surface-900">{user?.nome || 'Usuário'}</p>
                            <p className="text-xs text-surface-700/60 capitalize">{user?.perfil || 'admin'}</p>
                        </div>
                        <div className="w-9 h-9 rounded-xl bg-primary-100 flex items-center justify-center">
                            <User size={18} className="text-primary-600" />
                        </div>
                        <button
                            onClick={signOut}
                            className="p-2 rounded-xl hover:bg-danger-50 text-surface-700 hover:text-danger-600 transition-colors"
                            title="Sair"
                        >
                            <LogOut size={18} />
                        </button>
                    </div>
                </div>
            </div>
        </header>
    )
}
